import React, { useEffect, useRef } from 'react'

export type OutsideClickHandlerProps = {
  className?: string
  dropDownClassName?: string
  children: React.ReactNode
  onOutsideClick: () => void
  ignoreRefs?: React.RefObject<Node>[] | null
}

function ignoreElementClicked(
  event: any,
  ignoreRefs: React.RefObject<Node>[]
): boolean {
  for (const ignoreRef of ignoreRefs) {
    if (ignoreRef?.current?.contains(event.target) === true) {
      return true
    }
  }
  return false
}

function clickIsOutsideContainerAndNotOnIgnoreElement(
  event: any,
  ref: React.RefObject<Node>,
  ignoreRefs: React.RefObject<Node>[]
): boolean {
  return (
    ref.current !== null &&
    !ref.current.contains(event.target) &&
    !ignoreElementClicked(event, ignoreRefs)
  )
}

function useOutsideAlerter(
  ref: React.RefObject<Node>,
  onOutsideClick: () => void,
  ignoreRefs: React.RefObject<Node>[]
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (
        clickIsOutsideContainerAndNotOnIgnoreElement(event, ref, ignoreRefs)
      ) {
        onOutsideClick()
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}

export const OutsideClickHandler = ({
  className,
  children,
  onOutsideClick,
  ignoreRefs
}: OutsideClickHandlerProps) => {
  const wrapperRef = useRef(null)

  useOutsideAlerter(
    wrapperRef,
    onOutsideClick,
    ignoreRefs === undefined || ignoreRefs === null ? [] : ignoreRefs
  )

  return (
    <div className={`${className}`} ref={wrapperRef}>
      {children}
    </div>
  )
}
